import { Provider, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, map, distinctUntilChanged } from 'rxjs/operators';
import { ANALYTICS_SCRIPTS } from '../analytics.tokens';
import { AnalyticsService } from '../analytics.service';

export function provideAnalyticsRouterTracking(): Provider[] {
  return [
    {
      provide: ANALYTICS_SCRIPTS,
      multi: true,
      useFactory: () => {
        const router = inject(Router);
        const analytics = inject(AnalyticsService);

        router.events
          .pipe(
            filter((e): e is NavigationEnd => e instanceof NavigationEnd),
            map((e) => e.urlAfterRedirects),
            distinctUntilChanged()
          )
          .subscribe((url) => {
            analytics.trackPage(url);
          });
      }
    }
  ];
}
